export { default } from "./Options.page";
